import { useEffect, useState } from 'react';

// One responsive build: `isPhone` drives the compact layout, `narrow` collapses
// the multi-column grids. Both follow the real viewport. `phoneMax` is passed
// by each form, because it has to match the phone breakpoint in that form's CSS.
export const useDevice = (phoneMax = 700, narrowMax = 900) => {
  const read = () => ({ isPhone: window.innerWidth < phoneMax, narrow: window.innerWidth < narrowMax });
  const [size, setSize] = useState(read);

  useEffect(() => {
    const onResize = () => setSize(read());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phoneMax, narrowMax]);

  return size;
};
